export interface LangRoutesData {
  slug: string
  title: string
  description: string
  descriptionPerGame?: Record<string, string>
}

interface RouteTranslations {
  [locale: string]: LangRoutesData
}

export const routesTranslations: Record<string, RouteTranslations> = {
  'home-page': {
    en: {
      slug: '',
      title: 'Store - Gamesture',
      description: 'Gamesture Store: Elevate Your Gaming Experience, Master Your Fun!'
    },
    pl: {
      slug: '',
      title: 'Sklep - Gamesture',
      description: 'Sklep Gamesture: Wznieś swoją rozgrywkę na wyższy poziom i baw się jak mistrz!'
    },
    de: {
      slug: '',
      title: 'Shop - Gamesture',
      description: 'Gamesture Shop: Steigere dein Spielerlebnis, beherrsche deinen Spaß!'
    },
    fr: {
      slug: '',
      title: 'Boutique - Gamesture',
      description: 'Boutique Gamesture : Élevez votre expérience de jeu, maîtrisez votre plaisir !'
    },
    es: {
      slug: '',
      title: 'Tienda - Gamesture',
      description: 'Tienda Gamesture: ¡Eleva tu experiencia de juego, domina tu diversión!'
    },
    pt: {
      slug: '',
      title: 'Loja - Gamesture',
      description: 'Loja Gamesture: Eleve sua experiência de jogo, domine sua diversão!'
    },
    zh: {
      slug: '',
      title: '商店 - Gamesture',
      description: 'Gamesture 商店：提升您的游戏体验，掌控您的乐趣！'
    },
    ru: {
      slug: '',
      title: 'Магазин - Gamesture',
      description: 'Магазин Gamesture: Поднимите свой игровой опыт на новый уровень!'
    },
    it: {
      slug: '',
      title: 'Negozio - Gamesture',
      description: 'Negozio Gamesture: Eleva la tua esperienza di gioco, padroneggia il tuo divertimento!'
    },
    ko: {
      slug: '',
      title: '스토어 - Gamesture',
      description: 'Gamesture 스토어: 게임 경험을 높이고, 즐거움을 마스터하세요!'
    },
    ja: {
      slug: '',
      title: 'ストア - Gamesture',
      description: 'Gamesture ストア：ゲーム体験を高め、楽しさをマスターしよう！'
    },
    cs: {
      slug: '',
      title: 'Obchod - Gamesture',
      description: 'Obchod Gamesture: Posuňte svůj herní zážitek na vyšší úroveň!'
    },
    bg: {
      slug: '',
      title: 'Магазин - Gamesture',
      description: 'Магазин Gamesture: Издигнете игровото си преживяване на следващото ниво!'
    },
    nl: {
      slug: '',
      title: 'Winkel - Gamesture',
      description: 'Gamesture Winkel: Verbeter uw game-ervaring, beheers uw plezier!'
    }
  },
  'game-page': {
    en: {
      slug: 'game/:gameID',
      title: '{gameName} game - Gamesture store',
      description: 'Gear up with The {gameName} game: Your One-Stop Mobile Gaming Shop!', // if not defined per game
      descriptionPerGame: {
        gang: 'Gear up with The Gang: Your One-Stop Mobile Gaming Shop!',
        slashAndRoll: 'Slash and Roll Store: Level Up Your Gaming Style!',
        soccerClash: 'Join Soccer Clash today and be the world champion you dreamed! Step into the grand arena of Soccer Clash, a top-tier football simulator that embarks you on a riveting football career. Rise from backyard football skirmishes to European Championships, touching the zenith of pro football stardom.',
        questland: 'HIGHLY ADDICTIVE FANTASY GAME!\n' +
          'A FIRST-PERSON PERSPECTIVE RPG WITH ELEMENTS OF A DUNGEON CRAWLER. AN IMMERSIVE MOBILE EXPERIENCE THAT CARRIES THE LEGACY OF GAMES WE PLAYED AS KIDS.\n' +
          'Collect exquisite gear, customize your hero with hundreds of looks, and upgrade your way to the top with powerful Orbs and enhancements. Fight epic monsters, duel other players online, create Guilds, and more in this incredibly dynamic turn-based action game with CCG elements!',
        mafia: 'Enter the Mafia life, make the grand city your own!\n' +
          'Build your mafia family. Make your own rules. Take over the city. Time to step in and let the grand mafia game begin, Mafioso!\n',
        cooking: 'Join Cooking Wars today and build the restaurant empire you\'ve always dreamed of! Step into the fast-paced world of Cooking Wars, where every order, upgrade, and Cooking Show brings you closer to culinary fame. Start with a small kitchen, unlock powerful recipes, compete against rival chefs, and rise through the ranks to become a true cooking legend.'
      }
    },
    pl: {
      slug: 'gra/:gameID',
      title: '{gameName} gra – Sklep Gamesture',
      description: 'Przygotuj się na przygodę w grze {gameName} – Twoim jedynym miejscu na najlepsze mobilne zakupy!', // if not defined per game
      descriptionPerGame: {
        gang: 'Przygotuj się z The Gang: Twój kompleksowy sklep z grami mobilnymi!',
        slashAndRoll: 'Sklep Slash and Roll: Podkręć swój styl gry!',
        soccerClash: 'Dołącz do Soccer Clash już dziś i zostań mistrzem świata, o którym marzyłeś! Wejdź na wielką arenę Soccer Clash — najwyższej klasy symulatora piłki nożnej, który rozpocznie Twoją ekscytującą karierę futbolową. Wznieś się od podwórkowych rozgrywek do Mistrzostw Europy, sięgając szczytu profesjonalnej piłkarskiej sławy.',
        questland: 'NIEZWYKLE WCIĄGAJĄCA GRA FANTASY!\n' +
          'RPG Z PERSPEKTYWY PIERWSZEJ OSOBY Z ELEMENTAMI DUNGEON CRAWLERA. IMMERSYJNE DOŚWIADCZENIE MOBILNE, KTÓRE NAWIĄZUJE DO GIER, W KTÓRE GRALIŚMY JAKO DZIECI.\n' +
          'Zbieraj wyjątkowy ekwipunek, personalizuj swojego bohatera setkami wyglądów i wspinaj się na szczyt dzięki potężnym Kulom oraz ulepszeniom. Walcz z epickimi potworami, pojedynkuj się z innymi graczami online, twórz Gildie i odkrywaj jeszcze więcej w tej niezwykle dynamicznej, turowej grze akcji z elementami CCG!',
        mafia: 'Wejdź w mafijne życie i uczyń wielkie miasto swoim!\n' +
          'Zbuduj swoją mafię. Ustalaj własne zasady. Przejmij kontrolę nad miastem. Czas wkroczyć do gry i rozpocząć wielką mafijną rozgrywkę, Mafioso!\n',
        cooking: 'Dołącz do Cooking Wars już dziś i zbuduj imperium restauracji, o którym zawsze marzyłeś! Wkrocz w dynamiczny świat Cooking Wars, gdzie każde zamówienie, ulepszenie i Cooking Show przybliża Cię do kulinarnej sławy. Zacznij od małej kuchni, odkrywaj potężne przepisy, rywalizuj z innymi szefami kuchni i wspinaj się na szczyt, by stać się prawdziwą legendą gotowania.'
      }
    },
    de: {
      slug: 'spiel/:gameID',
      title: '{gameName} spiel – Gamesture Shop',
      description: 'Rüste dich für das Spiel {gameName} aus – dein ultimativer One-Stop-Shop für Mobile Gaming!', // if not defined per game
      descriptionPerGame: {
        gang: 'Rüste dich mit The Gang aus: Dein One-Stop-Shop für Mobile Games!',
        slashAndRoll: 'Slash and Roll Store: Hebe deinen Spielstil auf das nächste Level!',
        soccerClash: 'Tritt noch heute Soccer Clash bei und werde der Weltmeister, von dem du immer geträumt hast! Betritt die große Arena von Soccer Clash, einem erstklassigen Fußballsimulator, der dich auf eine spannende Fußballkarriere schickt. Steige von Hinterhof-Duellen bis zu den Europameisterschaften auf und erreiche den Gipfel des Profifußball-Ruhms.',
        questland: 'HOCHGRADIG SÜCHTIG MACHENDES FANTASY-SPIEL!\n' +
          'EIN RPG AUS DER EGO-PERSPEKTIVE MIT DUNGEON-CRAWLER-ELEMENTEN. EIN MITREISSENDES MOBILES ERLEBNIS, DAS DAS VERMÄCHTNIS DER SPIELE FORTFÜHRT, DIE WIR ALS KINDER GESPIELT HABEN.\n' +
          'Sammle außergewöhnliche Ausrüstung, gestalte deinen Helden mit Hunderten von Looks und arbeite dich mit mächtigen Orbs und Verbesserungen an die Spitze. Bekämpfe epische Monster, duelliere dich online mit anderen Spielern, gründe Gilden und vieles mehr in diesem unglaublich dynamischen, rundenbasierten Actionspiel mit CCG-Elementen!',
        mafia: 'Tauche ein in das Mafia-Leben und mache die große Stadt zu deiner!\n' +
          'Baue deine Mafiafamilie auf. Stelle deine eigenen Regeln auf. Übernimm die Kontrolle über die Stadt. Es ist Zeit einzusteigen und das große Mafia-Spiel zu beginnen, Mafioso!\n',
        cooking: 'Tritt Cooking Wars noch heute bei und baue das Restaurantimperium auf, von dem du immer geträumt hast! Tauche ein in die dynamische Welt von Cooking Wars, wo jede Bestellung, jedes Upgrade und jede Cooking Show dich dem kulinarischen Ruhm näher bringt. Beginne mit einer kleinen Küche, schalte mächtige Rezepte frei, tritt gegen rivalisierende Köche an und steige in den Rängen auf, um zur wahren Kochlegende zu werden.'
      }
    },
    fr: {
      slug: 'jeu/:gameID',
      title: '{gameName} jeu – Boutique Gamesture',
      description: 'Préparez-vous pour le jeu {gameName} – votre boutique unique pour le gaming mobile !', // if not defined per game
      descriptionPerGame: {
        gang: 'Préparez-vous avec The Gang : votre boutique unique pour les jeux mobiles !',
        slashAndRoll: 'Boutique Slash and Roll : Élevez votre style de jeu au niveau supérieur !',
        soccerClash: 'Rejoignez Soccer Clash aujourd\'hui et devenez le champion du monde dont vous avez toujours rêvé ! Entrez dans la grande arène de Soccer Clash, un simulateur de football de premier ordre qui vous embarque dans une carrière footballistique palpitante. Montez des matchs de cour d\'école aux Championnats d\'Europe, atteignant le sommet de la gloire footballistique professionnelle.',
        questland: 'JEU FANTASTIQUE EXTRÊMEMENT ADDICTIF !\n' +
          'UN RPG EN PERSPECTIVE À LA PREMIÈRE PERSONNE AVEC DES ÉLÉMENTS DE DUNGEON CRAWLER. UNE EXPÉRIENCE MOBILE IMMERSIVE QUI PERPÉTUE L\'HÉRITAGE DES JEUX AUXQUELS NOUS JOUIONS ENFANTS.\n' +
          'Collectez un équipement exquis, personnalisez votre héros avec des centaines de looks, et progressez au sommet grâce à de puissants Orbes et améliorations. Combattez des monstres épiques, affrontez d\'autres joueurs en ligne, créez des Guildes, et bien plus encore dans ce jeu d\'action au tour par tour incroyablement dynamique avec des éléments CCG !',
        mafia: 'Entrez dans la vie mafieuse et faites de la grande ville la vôtre !\n' +
          'Construisez votre famille mafieuse. Établissez vos propres règles. Prenez le contrôle de la ville. Il est temps d\'entrer en jeu et de commencer la grande partie mafieuse, Mafioso !\n',
        cooking: 'Rejoignez Cooking Wars aujourd\'hui et construisez l\'empire de restauration dont vous avez toujours rêvé ! Plongez dans le monde trépidant de Cooking Wars, où chaque commande, amélioration et Cooking Show vous rapproche de la gloire culinaire. Commencez avec une petite cuisine, débloquez des recettes puissantes, affrontez des chefs rivaux et montez en grade pour devenir une véritable légende de la cuisine.'
      }
    },
    es: {
      slug: 'juego/:gameID',
      title: '{gameName} juego – Tienda Gamesture',
      description: '¡Prepárate para el juego {gameName} – tu tienda única para gaming móvil!', // if not defined per game
      descriptionPerGame: {
        gang: '¡Prepárate con The Gang: tu tienda única para juegos móviles!',
        slashAndRoll: '¡Tienda Slash and Roll: Lleva tu estilo de juego al siguiente nivel!',
        soccerClash: '¡Únete a Soccer Clash hoy y conviértete en el campeón del mundo que siempre soñaste! Entra en la gran arena de Soccer Clash, un simulador de fútbol de primer nivel que te embarca en una emocionante carrera futbolística. Sube desde partidos de patio hasta los Campeonatos de Europa, alcanzando la cima de la fama del fútbol profesional.',
        questland: '¡JUEGO DE FANTASÍA ALTAMENTE ADICTIVO!\n' +
          'UN RPG EN PRIMERA PERSONA CON ELEMENTOS DE DUNGEON CRAWLER. UNA EXPERIENCIA MÓVIL INMERSIVA QUE LLEVA EL LEGADO DE LOS JUEGOS QUE JUGÁBAMOS DE NIÑOS.\n' +
          '¡Colecciona equipo exquisito, personaliza tu héroe con cientos de apariencias y súbete a la cima con poderosos Orbes y mejoras. Lucha contra monstruos épicos, duéla con otros jugadores en línea, crea Gremios y mucho más en este increíblemente dinámico juego de acción por turnos con elementos CCG!',
        mafia: '¡Entra en la vida de la Mafia y haz tuya la gran ciudad!\n' +
          '¡Construye tu familia mafiosa. Establece tus propias reglas. Toma el control de la ciudad. Es hora de entrar y dejar que comience el gran juego de la mafia, Mafioso!\n',
        cooking: '¡Únete a Cooking Wars hoy y construye el imperio de restaurantes con el que siempre has soñado! Adéntrate en el vertiginoso mundo de Cooking Wars, donde cada pedido, mejora y Cooking Show te acerca más a la fama culinaria. Empieza con una pequeña cocina, desbloquea recetas poderosas, compite contra chefs rivales y escala posiciones para convertirte en una auténtica leyenda culinaria.'
      }
    },
    pt: {
      slug: 'jogo/:gameID',
      title: '{gameName} jogo – Loja Gamesture',
      description: 'Prepare-se para o jogo {gameName} – sua loja única para gaming móvel!', // if not defined per game
      descriptionPerGame: {
        gang: 'Prepare-se com The Gang: sua loja única para jogos móveis!',
        slashAndRoll: 'Loja Slash and Roll: Leve seu estilo de jogo ao próximo nível!',
        soccerClash: 'Junte-se ao Soccer Clash hoje e torne-se o campeão do mundo que você sempre sonhou! Entre na grande arena do Soccer Clash, um simulador de futebol de primeira linha que embarca você em uma emocionante carreira futebolística. Suba de partidas de quintal aos Campeonatos Europeus, alcançando o zênite da fama do futebol profissional.',
        questland: 'JOGO DE FANTASIA ALTAMENTE VICIANTE!\n' +
          'UM RPG EM PRIMEIRA PESSOA COM ELEMENTOS DE DUNGEON CRAWLER. UMA EXPERIÊNCIA MÓVEL IMERSIVA QUE CARREGA O LEGADO DOS JOGOS QUE JOGÁVAMOS QUANDO CRIANÇAS.\n' +
          'Colecione equipamentos requintados, personalize seu herói com centenas de visuais e suba ao topo com poderosos Orbes e melhorias. Lute contra monstros épicos, duela com outros jogadores online, crie Guildas e muito mais neste jogo de ação por turnos incrivelmente dinâmico com elementos CCG!',
        mafia: 'Entre na vida da Máfia e faça da grande cidade a sua!\n' +
          'Construa sua família mafiosa. Estabeleça suas próprias regras. Tome o controle da cidade. É hora de entrar e deixar o grande jogo da máfia começar, Mafioso!\n',
        cooking: 'Junte-se ao Cooking Wars hoje e construa o império de restaurantes com que sempre sonhou! Entre no mundo acelerado de Cooking Wars, onde cada pedido, melhoria e Cooking Show aproxima você da fama culinária. Comece com uma pequena cozinha, desbloqueie receitas poderosas, compita contra chefs rivais e suba nas classificações para se tornar uma verdadeira lenda culinária.'
      }
    },
    zh: {
      slug: 'game/:gameID',
      title: '{gameName} 游戏 – Gamesture 商店',
      description: '为 {gameName} 游戏做好准备 – 您的一站式移动游戏商店！', // if not defined per game
      descriptionPerGame: {
        gang: '准备好迎接 The Gang：您的一站式移动游戏商店！',
        slashAndRoll: 'Slash and Roll 商店：提升您的游戏风格！',
        soccerClash: '今天加入 Soccer Clash，成为您梦想中的世界冠军！踏入 Soccer Clash 的大舞台，这是一款顶级足球模拟器，带您踏上激动人心的足球职业生涯。从后院足球赛一路晋升到欧洲锦标赛，触及职业足球明星的巅峰。',
        questland: '极具成瘾性的奇幻游戏！\n' +
          '第一人称视角RPG，融合地下城爬行元素。沉浸式移动体验，传承我们童年时玩的游戏遗产。\n' +
          '收集精美装备，用数百种外观定制您的英雄，并通过强大的宝珠和强化升级到顶端。与史诗怪物战斗，与其他玩家在线决斗，创建公会，以及在这款带有CCG元素的令人难以置信的动态回合制动作游戏中体验更多！',
        mafia: '进入黑手党生活，让大城市成为您的！\n' +
          '建立您的黑手党家族。制定您自己的规则。控制这座城市。是时候踏入并让黑手党大游戏开始，Mafioso！\n',
        cooking: '今天就加入 Cooking Wars，打造您梦寐以求的餐厅帝国！踏入 Cooking Wars 快节奏的世界，每一个订单、升级和烹饪秀都让您距离烹饪名声更近一步。从小厨房起步，解锁强大食谱，与竞争对手主厨争高下，不断晋升，成为真正的烹饪传奇。'
      }
    },
    ru: {
      slug: 'igra/:gameID',
      title: '{gameName} игра – Магазин Gamesture',
      description: 'Подготовьтесь к игре {gameName} – ваш универсальный магазин мобильных игр!', // if not defined per game
      descriptionPerGame: {
        gang: 'Подготовьтесь с The Gang: ваш универсальный магазин мобильных игр!',
        slashAndRoll: 'Магазин Slash and Roll: Поднимите свой стиль игры на новый уровень!',
        soccerClash: 'Присоединяйтесь к Soccer Clash сегодня и станьте чемпионом мира, о котором вы мечтали! Вступите на великую арену Soccer Clash, симулятора футбола высшего уровня, который отправит вас в захватывающую футбольную карьеру. Поднимитесь от дворовых матчей до чемпионатов Европы, достигнув вершины профессиональной футбольной славы.',
        questland: 'НЕВЕРОЯТНО ЗАХВАТЫВАЮЩАЯ ФЭНТЕЗИЙНАЯ ИГРА!\n' +
          'RPG ОТ ПЕРВОГО ЛИЦА С ЭЛЕМЕНТАМИ DUNGEON CRAWLER. ЗАХВАТЫВАЮЩИЙ МОБИЛЬНЫЙ ОПЫТ, НЕСУЩИЙ НАСЛЕДИЕ ИГР, В КОТОРЫЕ МЫ ИГРАЛИ В ДЕТСТВЕ.\n' +
          'Собирайте изысканное снаряжение, настраивайте героя с сотнями образов и продвигайтесь на вершину с мощными Сферами и улучшениями. Сражайтесь с эпическими монстрами, дуэлируйте с другими игроками онлайн, создавайте Гильдии и многое другое в этой невероятно динамичной пошаговой экшн-игре с элементами CCG!',
        mafia: 'Войдите в жизнь Мафии и сделайте великий город своим!\n' +
          'Создайте свою мафиозную семью. Установите свои правила. Захватите контроль над городом. Время вступить в игру и позволить начаться великой игре мафии, Mafioso!\n',
        cooking: 'Присоединяйтесь к Cooking Wars сегодня и постройте ресторанную империю, о которой вы всегда мечтали! Окунитесь в стремительный мир Cooking Wars, где каждый заказ, улучшение и Cooking Show приближают вас к кулинарной славе. Начните с маленькой кухни, открывайте мощные рецепты, соревнуйтесь с шеф-поварами соперниками и поднимайтесь в рейтинге, чтобы стать настоящей легендой кулинарии.'
      }
    },
    it: {
      slug: 'gioco/:gameID',
      title: '{gameName} gioco – Negozio Gamesture',
      description: 'Preparati per il gioco {gameName} – il tuo negozio unico per il gaming mobile!', // if not defined per game
      descriptionPerGame: {
        gang: 'Preparati con The Gang: il tuo negozio unico per i giochi mobile!',
        slashAndRoll: 'Negozio Slash and Roll: Porta il tuo stile di gioco al livello successivo!',
        soccerClash: 'Unisciti a Soccer Clash oggi e diventa il campione del mondo che hai sempre sognato! Entra nella grande arena di Soccer Clash, un simulatore di calcio di primo livello che ti porta in una carriera calcistica avvincente. Sali dalle partite di cortile ai Campionati Europei, raggiungendo il vertice della fama calcistica professionistica.',
        questland: 'GIOCO FANTASY ALTAMENTE COINVOLGENTE!\n' +
          'UN RPG IN PRIMA PERSONA CON ELEMENTI DI DUNGEON CRAWLER. UN\'ESPERIENZA MOBILE IMMERSIVA CHE PORTA L\'EREDITÀ DEI GIOCHI CHE GIOCAVAMO DA BAMBINI.\n' +
          'Raccogli equipaggiamento squisito, personalizza il tuo eroe con centinaia di look e scala la vetta con potenti Sfere e potenziamenti. Combatti mostri epici, duella con altri giocatori online, crea Gilde e molto altro in questo gioco d\'azione a turni incredibilmente dinamico con elementi CCG!',
        mafia: 'Entra nella vita della Mafia e fai tua la grande città!\n' +
          'Costruisci la tua famiglia mafiosa. Stabilisci le tue regole. Prendi il controllo della città. È tempo di entrare in gioco e far iniziare il grande gioco della mafia, Mafioso!\n',
        cooking: 'Unisciti a Cooking Wars oggi e costruisci l\'impero di ristoranti di cui hai sempre sognato! Immergiti nel frenetico mondo di Cooking Wars, dove ogni ordine, upgrade e Cooking Show ti avvicina alla fama culinaria. Inizia con una piccola cucina, sblocca ricette potenti, gareggia contro chef rivali e scala le classifiche per diventare una vera leggenda della cucina.'
      }
    },
    ko: {
      slug: 'game/:gameID',
      title: '{gameName} 게임 – Gamesture 스토어',
      description: '{gameName} 게임 준비 완료 – 모바일 게임 원스톱 쇼핑!', // if not defined per game
      descriptionPerGame: {
        gang: 'The Gang과 함께 준비하세요: 모바일 게임 원스톱 쇼핑!',
        slashAndRoll: 'Slash and Roll 스토어: 게임 스타일을 한 단계 업그레이드하세요!',
        soccerClash: '오늘 Soccer Clash에 참여하여 꿈꿔왔던 세계 챔피언이 되세요! 최고의 축구 시뮬레이터 Soccer Clash의 대무대에 발을 내딛어 짜릿한 축구 커리어를 시작하세요. 동네 축구에서 유럽 챔피언십까지, 프로 축구 스타의 정점을 향해 달려가세요.',
        questland: '매우 중독성 있는 판타지 게임!\n' +
          '던전 크롤러 요소를 가진 1인칭 시점 RPG. 어릴 때 플레이했던 게임의 유산을 이어받은 몰입감 넘치는 모바일 경험.\n' +
          '정교한 장비를 수집하고, 수백 가지 외형으로 영웅을 커스터마이즈하고, 강력한 오브와 강화로 정상에 올라가세요. 이 믿을 수 없을 만큼 역동적인 턴제 액션 게임에서 서사시적 몬스터와 싸우고, 다른 플레이어와 대결하고, 길드를 만들고, CCG 요소를 경험하세요!',
        mafia: '마피아 생활에 입문하여 대도시를 당신의 것으로 만드세요!\n' +
          '마피아 가문을 구축하세요. 자신만의 규칙을 세우세요. 도시를 장악하세요. 이제 들어설 시간입니다, 대장!\n',
        cooking: '지금 Cooking Wars에 참여하여 항상 꿈꿔왔던 레스토랑 제국을 건설하세요! 빠른 속도의 Cooking Wars 세계로 발을 내딛어 보세요. 모든 주문, 업그레이드, 쿠킹 쇼가 요리 명성에 한 발 더 가까이 데려다 줍니다. 작은 주방에서 시작하여 강력한 레시피를 잠금 해제하고, 라이벌 셰프들과 경쟁하며, 진정한 요리 전설이 되기 위해 순위를 올려가세요.'
      }
    },
    ja: {
      slug: 'game/:gameID',
      title: '{gameName} ゲーム – Gamesture ストア',
      description: '{gameName} ゲームに備えよう – モバイルゲームのワンストップショップ！', // if not defined per game
      descriptionPerGame: {
        gang: 'The Gangで準備完了：モバイルゲームのワンストップショップ！',
        slashAndRoll: 'Slash and Roll ストア：ゲームスタイルをレベルアップしよう！',
        soccerClash: '今日Soccer Clashに参加して、夢見ていた世界チャンピオンになろう！トップクラスのサッカーシミュレーターSoccer Clashの大舞台に足を踏み入れ、スリリングなサッカーキャリアへ出発。裏庭のサッカーからヨーロッパ選手権まで、プロサッカーの頂点を目指そう。',
        questland: '非常に中毒性の高いファンタジーゲーム！\n' +
          'ダンジョンクローラーの要素を持つ一人称視点RPG。子供の頃にプレイしたゲームの遺産を受け継ぐ没入型モバイル体験。\n' +
          '精巧な装備を集め、何百もの外見でヒーローをカスタマイズし、強力なオーブと強化で頂点に登ろう。このCCG要素を持つ信じられないほどダイナミックなターン制アクションゲームで、壮大なモンスターと戦い、他のプレイヤーとデュエルし、ギルドを作り、さらに多くを体験しよう！',
        mafia: 'マフィアの生活に入り、大都市を自分のものにしよう！\n' +
          'マフィアファミリーを築こう。自分のルールを作ろう。都市を支配しよう。今こそ入場して、大きなマフィアゲームを始める時だ、マフィオーソ！\n',
        cooking: '今日 Cooking Wars に参加して、ずっと夢見ていたレストラン帝国を築こう！Cooking Wars のスピード感あふれる世界に飛び込もう。すべての注文、アップグレード、クッキングショーが料理の名声へと近づけてくれます。小さなキッチンから始め、強力なレシピを解放し、ライバルシェフと競い、ランクを上げて真の料理の伝説になろう。'
      }
    },
    cs: {
      slug: 'hra/:gameID',
      title: '{gameName} hra – Obchod Gamesture',
      description: 'Připravte se na hru {gameName} – váš komplexní obchod pro mobilní hraní!', // if not defined per game
      descriptionPerGame: {
        gang: 'Připravte se s The Gang: Váš komplexní obchod pro mobilní hry!',
        slashAndRoll: 'Obchod Slash and Roll: Posuňte svůj herní styl na další úroveň!',
        soccerClash: 'Připojte se k Soccer Clash ještě dnes a staňte se mistrem světa, o kterém jste vždy snili! Vstupte na velkou arénu Soccer Clash, špičkového fotbalového simulátoru, který vás vypraví na strhující fotbalovou kariéru. Stoupejte od dvorních zápasů až po Mistrovství Evropy a dosáhněte vrcholu profesionální fotbalové slávy.',
        questland: 'VYSOCE NÁVYKOVÁ FANTASY HRA!\n' +
          'RPG Z POHLEDU PRVNÍ OSOBY S PRVKY DUNGEON CRAWLERU. POHLCUJÍCÍ MOBILNÍ ZÁŽITEK, KTERÝ NESE DĚDICTVÍ HER, DO NICHŽ JSME HRÁLI JAKO DĚTI.\n' +
          'Sbírejte výjimečné vybavení, přizpůsobujte si hrdinu stovkami vzhledů a šplhejte na vrchol pomocí mocných Sfér a vylepšení. Bojujte s epickými příšerami, soubojujte s ostatními hráči online, zakládejte Cechy a mnoho dalšího v této neuvěřitelně dynamické tahové akční hře s prvky CCG!',
        mafia: 'Vstupte do mafijského života a učiňte velké město svým!\n' +
          'Budujte svoji mafijskou rodinu. Stanovte si vlastní pravidla. Převezměte kontrolu nad městem. Je čas vstoupit a zahájit velkou mafijskou hru, Mafioso!\n',
        cooking: 'Připojte se k Cooking Wars ještě dnes a vybudujte restaurantní impérium, o kterém jste vždy snili! Vstupte do dynamického světa Cooking Wars, kde každá objednávka, upgrade a Cooking Show vás přibližuje kulinářské slávě. Začněte s malou kuchyní, odemkněte mocné recepty, soupeřte s rivaly-kuchaři a postupujte v žebříčcích, abyste se stali pravou kulinářskou legendou.'
      }
    },
    bg: {
      slug: 'igra/:gameID',
      title: '{gameName} игра – Магазин Gamesture',
      description: 'Подгответе се за играта {gameName} – вашият универсален магазин за мобилни игри!', // if not defined per game
      descriptionPerGame: {
        gang: 'Подгответе се с The Gang: Вашият универсален магазин за мобилни игри!',
        slashAndRoll: 'Магазин Slash and Roll: Издигнете стила си на игра на следващото ниво!',
        soccerClash: 'Присъединете се към Soccer Clash днес и станете световния шампион, за когото сте мечтали! Влезте в голямата арена на Soccer Clash, първокласен футболен симулатор, който ви изпраща в завладяваща футболна кариера. Изкачете се от дворни мачове до Европейски първенства, достигайки върха на професионалната футболна слава.',
        questland: 'СИЛНО ЗАВЛАДЯВАЩА ФЕНТЪЗИ ИГРА!\n' +
          'RPG ОТ ПЪРВО ЛИЦЕ С ЕЛЕМЕНТИ НА DUNGEON CRAWLER. ЗАВЛАДЯВАЩО МОБИЛНО ПРЕЖИВЯВАНЕ, КОЕТО НОСИ НАСЛЕДСТВОТО НА ИГРИТЕ, В КОИТО ИГРАХМЕ КАТО ДЕЦА.\n' +
          'Събирайте изискано снаряжение, персонализирайте героя си със стотици изгледи и се изкачвайте на върха с мощни Сфери и подобрения. Сражавайте се с епични чудовища, дуелирайте се с други играчи онлайн, създавайте Гилдии и много повече в тази невероятно динамична пошагова екшън игра с елементи на CCG!',
        mafia: 'Влезте в живота на Мафията и направете голямата градина своя!\n' +
          'Изградете своето мафиотско семейство. Установете собствените си правила. Превземете контрола над града. Дошло е времето да влезете и да позволите на голямата мафиотска игра да започне, Mafioso!\n',
        cooking: 'Присъединете се към Cooking Wars днес и изградете ресторантската империя, за която сте мечтали! Стъпете в динамичния свят на Cooking Wars, където всяка поръчка, надграждане и Cooking Show ви приближава към кулинарна слава. Започнете с малка кухня, отключвайте мощни рецепти, съревновавайте се с готвачи съперници и се изкачвайте в класациите, за да станете истинска кулинарна легенда.'
      }
    },
    nl: {
      slug: 'spel/:gameID',
      title: '{gameName} spel – Gamesture Winkel',
      description: 'Maak je klaar voor het spel {gameName} – uw alles-in-één winkel voor mobiel gamen!', // if not defined per game
      descriptionPerGame: {
        gang: 'Maak je klaar met The Gang: Uw alles-in-één winkel voor mobiele games!',
        slashAndRoll: 'Slash and Roll Winkel: Til uw spelstijl naar het volgende niveau!',
        soccerClash: 'Doe vandaag mee met Soccer Clash en word de wereldkampioen waar u altijd van heeft gedroomd! Betreed de grote arena van Soccer Clash, een eersteklas voetbalsimulator die u op een spannende voetbalcarrière stuurt. Klim van achtertuinvoetbal naar Europese kampioenschappen en bereik het toppunt van professionele voetbalroem.',
        questland: 'UITERST VERSLAVEND FANTASY SPEL!\n' +
          'EEN RPG VANUIT EERSTE PERSOONSPERSPECTIEF MET ELEMENTEN VAN EEN DUNGEON CRAWLER. EEN MEESLEPENDE MOBIELE ERVARING DIE DE ERFENIS DRAAGT VAN SPELLEN DIE WE ALS KIND SPEELDEN.\n' +
          'Verzamel prachtige uitrusting, personaliseer uw held met honderden looks en werk uw weg naar de top met krachtige Orbs en verbeteringen. Vecht tegen epische monsters, duelleer met andere spelers online, maak Gildes en meer in dit ongelooflijk dynamische beurtgebaseerde actiespel met CCG-elementen!',
        mafia: 'Tred in het mafialeven en maak de grote stad het uwe!\n' +
          'Bouw uw mafiafamilie op. Stel uw eigen regels in. Neem de controle over de stad. Tijd om in te stappen en het grote mafiaspel te laten beginnen, Mafioso!\n',
        cooking: 'Doe vandaag mee met Cooking Wars en bouw het restaurantimperium waarvan je altijd hebt gedroomd! Stap in de dynamische wereld van Cooking Wars, waar elke bestelling, upgrade en Cooking Show je dichter bij culinaire roem brengt. Begin met een kleine keuken, ontgrendel krachtige recepten, strijd tegen rivaliserende chefs en klim in de ranglijsten om een echte culinaire legende te worden.'
      }
    }
  },
  'game-product-page': {
    en: {
      slug: 'game/:gameID/offer/:offerID',
      title: 'Offer {offerID} - {gameName} game - Gamesture store',
      description: '{gameName}: Exclusive In-Game Bundles Await! (offer: {offerID})'
    },
    pl: {
      slug: 'gra/:gameID/oferta/:offerID',
      title: 'Oferta {offerID} - {gameName} gra - Sklep Gamesture',
      description: '{gameName}: Ekskluzywne pakiety w grze czekają! (oferta: {offerID})'
    },
    de: {
      slug: 'spiel/:gameID/angebot/:offerID',
      title: 'Angebot {offerID} – Spiel {gameName} – Gamesture Shop',
      description: '{gameName}: Exklusive In-Game-Bundles warten auf dich! (angebot: {offerID})'
    },
    fr: {
      slug: 'jeu/:gameID/offre/:offerID',
      title: 'Offre {offerID} – Jeu {gameName} – Boutique Gamesture',
      description: '{gameName} : Des packs en jeu exclusifs vous attendent ! (offre : {offerID})'
    },
    es: {
      slug: 'juego/:gameID/oferta/:offerID',
      title: 'Oferta {offerID} – Juego {gameName} – Tienda Gamesture',
      description: '{gameName}: ¡Te esperan paquetes exclusivos en el juego! (oferta: {offerID})'
    },
    pt: {
      slug: 'jogo/:gameID/oferta/:offerID',
      title: 'Oferta {offerID} – Jogo {gameName} – Loja Gamesture',
      description: '{gameName}: Pacotes exclusivos no jogo aguardam! (oferta: {offerID})'
    },
    zh: {
      slug: 'game/:gameID/offer/:offerID',
      title: '优惠 {offerID} – {gameName} 游戏 – Gamesture 商店',
      description: '{gameName}：独家游戏内套装等您享！（优惠：{offerID}）'
    },
    ru: {
      slug: 'igra/:gameID/predlozhenie/:offerID',
      title: 'Предложение {offerID} – Игра {gameName} – Магазин Gamesture',
      description: '{gameName}: Эксклюзивные игровые наборы ждут вас! (предложение: {offerID})'
    },
    it: {
      slug: 'gioco/:gameID/offerta/:offerID',
      title: 'Offerta {offerID} – Gioco {gameName} – Negozio Gamesture',
      description: '{gameName}: Ti aspettano pacchetti esclusivi nel gioco! (offerta: {offerID})'
    },
    ko: {
      slug: 'game/:gameID/offer/:offerID',
      title: '오퍼 {offerID} – {gameName} 게임 – Gamesture 스토어',
      description: '{gameName}: 독점 인게임 번들이 기다립니다! (오퍼: {offerID})'
    },
    ja: {
      slug: 'game/:gameID/offer/:offerID',
      title: 'オファー {offerID} – {gameName} ゲーム – Gamesture ストア',
      description: '{gameName}：限定ゲーム内バンドルが待っています！（オファー：{offerID}）'
    },
    cs: {
      slug: 'hra/:gameID/nabidka/:offerID',
      title: 'Nabídka {offerID} – Hra {gameName} – Obchod Gamesture',
      description: '{gameName}: Exkluzivní herní balíčky čekají! (nabídka: {offerID})'
    },
    bg: {
      slug: 'igra/:gameID/predlozhenie/:offerID',
      title: 'Предложение {offerID} – Игра {gameName} – Магазин Gamesture',
      description: '{gameName}: Ексклузивни игрови пакети ви очакват! (предложение: {offerID})'
    },
    nl: {
      slug: 'spel/:gameID/aanbieding/:offerID',
      title: 'Aanbieding {offerID} – Spel {gameName} – Gamesture Winkel',
      description: '{gameName}: Exclusieve in-game bundels wachten! (aanbieding: {offerID})'
    }
  },
  'help-page': {
    en: {
      slug: 'help',
      title: 'Help - Gamesture store',
      description: 'If you have any questions please contact us with email: help@gamesture.com'
    },
    pl: {
      slug: 'pomoc',
      title: 'Pomoc – Sklep Gamesture',
      description: 'Jeśli masz jakiekolwiek pytania, skontaktuj się z nami pod adresem: help@gamesture.com'
    },
    de: {
      slug: 'hilfe',
      title: 'Hilfe – Gamesture Shop',
      description: 'Wenn du irgendwelche Fragen hast, kontaktiere uns bitte unter: help@gamesture.com'
    },
    fr: {
      slug: 'aide',
      title: 'Aide – Boutique Gamesture',
      description: 'Si vous avez des questions, veuillez nous contacter par e-mail : help@gamesture.com'
    },
    es: {
      slug: 'ayuda',
      title: 'Ayuda – Tienda Gamesture',
      description: 'Si tienes alguna pregunta, contáctanos por correo electrónico: help@gamesture.com'
    },
    pt: {
      slug: 'ajuda',
      title: 'Ajuda – Loja Gamesture',
      description: 'Se tiver alguma dúvida, entre em contato conosco por e-mail: help@gamesture.com'
    },
    zh: {
      slug: 'help',
      title: '帮助 – Gamesture 商店',
      description: '如有任何问题，请通过电子邮件联系我们：help@gamesture.com'
    },
    ru: {
      slug: 'pomoshch',
      title: 'Помощь – Магазин Gamesture',
      description: 'Если у вас есть вопросы, пожалуйста, свяжитесь с нами по электронной почте: help@gamesture.com'
    },
    it: {
      slug: 'aiuto',
      title: 'Aiuto – Negozio Gamesture',
      description: 'Se hai domande, contattaci via e-mail: help@gamesture.com'
    },
    ko: {
      slug: 'help',
      title: '도움말 – Gamesture 스토어',
      description: '질문이 있으시면 이메일로 문의하세요: help@gamesture.com'
    },
    ja: {
      slug: 'help',
      title: 'ヘルプ – Gamesture ストア',
      description: 'ご質問がある場合は、メールでお問い合わせください: help@gamesture.com'
    },
    cs: {
      slug: 'pomoc',
      title: 'Pomoc – Obchod Gamesture',
      description: 'Pokud máte jakékoli dotazy, kontaktujte nás prosím e-mailem: help@gamesture.com'
    },
    bg: {
      slug: 'pomosht',
      title: 'Помощ – Магазин Gamesture',
      description: 'Ако имате въпроси, моля свържете се с нас по имейл: help@gamesture.com'
    },
    nl: {
      slug: 'hulp',
      title: 'Hulp – Gamesture Winkel',
      description: 'Als u vragen heeft, neem dan contact met ons op via e-mail: help@gamesture.com'
    }
  },
  'about-page': {
    en: {
      slug: 'about',
      title: 'About - Gamesture store',
      description: 'New to the store? How fun! Here at Gamesture Store, we\'ve created a new way to offer the best deals for in-game products to our players. Buy and share game passes with your old friends or donate them to new ones. Reward a newbie or give yourself an extra long boost.'
    },
    pl: {
      slug: 'o-nas',
      title: 'O nas – Sklep Gamesture',
      description: 'Nowy w sklepie? Super! W Sklepie Gamesture stworzyliśmy nowy sposób oferowania najlepszych okazji na produkty w grach naszym graczom. Kupuj i udostępniaj przepustki do gier swoim starym znajomym lub podaruj je nowym. Nagrodź nowicjusza albo daj sobie dodatkowe, długie wzmocnienie.'
    },
    de: {
      slug: 'uber-uns',
      title: 'Über uns – Gamesture Shop',
      description: 'Neu im Shop? Wie schön! Im Gamesture Shop haben wir eine neue Möglichkeit geschaffen, unseren Spielern die besten Angebote für In-Game-Produkte zu bieten. Kaufe und teile Game-Pässe mit alten Freunden oder verschenke sie an neue. Belohne einen Neuling oder gönn dir selbst einen extra langen Boost.'
    },
    fr: {
      slug: 'a-propos',
      title: 'À propos – Boutique Gamesture',
      description: 'Nouveau dans la boutique ? Comme c\'est amusant ! Ici, chez Gamesture Store, nous avons créé une nouvelle façon d\'offrir les meilleures offres sur les produits en jeu à nos joueurs. Achetez et partagez des passes de jeu avec vos anciens amis ou offrez-les à de nouveaux. Récompensez un débutant ou offrez-vous un boost supplémentaire.'
    },
    es: {
      slug: 'acerca-de',
      title: 'Acerca de – Tienda Gamesture',
      description: '¿Nuevo en la tienda? ¡Qué divertido! Aquí en Gamesture Store, hemos creado una nueva forma de ofrecer las mejores ofertas de productos en el juego a nuestros jugadores. Compra y comparte pases de juego con tus viejos amigos o dónalos a nuevos. Recompensa a un novato o date un impulso extra largo.'
    },
    pt: {
      slug: 'sobre-nos',
      title: 'Sobre nós – Loja Gamesture',
      description: 'Novo na loja? Que divertido! Aqui na Gamesture Store, criamos uma nova forma de oferecer as melhores ofertas de produtos no jogo para nossos jogadores. Compre e compartilhe passes de jogo com seus velhos amigos ou doe-os para novos. Recompense um novato ou se dê um impulso extra longo.'
    },
    zh: {
      slug: 'about',
      title: '关于我们 – Gamesture 商店',
      description: '初次光临？太棒了！在 Gamesture 商店，我们为玩家创造了一种全新的方式来获取游戏内产品的最佳优惠。与老朋友购买并分享游戏通行证，或将其捐赠给新朋友。奖励新手或给自己一个超长加速。'
    },
    ru: {
      slug: 'o-nas',
      title: 'О нас – Магазин Gamesture',
      description: 'Новичок в магазине? Как здорово! Здесь, в Gamesture Store, мы создали новый способ предлагать нашим игрокам лучшие сделки на внутриигровые продукты. Покупайте и делитесь игровыми пропусками со старыми друзьями или жертвуйте их новым. Наградите новичка или дайте себе дополнительный длинный бустер.'
    },
    it: {
      slug: 'chi-siamo',
      title: 'Chi siamo – Negozio Gamesture',
      description: 'Nuovo nel negozio? Che divertimento! Qui al Gamesture Store, abbiamo creato un nuovo modo di offrire le migliori offerte sui prodotti nel gioco ai nostri giocatori. Acquista e condividi i pass di gioco con i tuoi vecchi amici o donali ai nuovi. Premia un principiante o concediti un boost extra lungo.'
    },
    ko: {
      slug: 'about',
      title: '소개 – Gamesture 스토어',
      description: '스토어가 처음이신가요? 재밌겠네요! Gamesture Store에서 우리는 플레이어들에게 게임 내 제품의 최고 혜택을 제공하는 새로운 방법을 만들었습니다. 오래된 친구들과 게임 패스를 사고 나누거나 새 친구들에게 기부하세요. 초보자에게 보상하거나 자신에게 추가 긴 부스트를 주세요.'
    },
    ja: {
      slug: 'about',
      title: 'について – Gamesture ストア',
      description: 'ストア初めてですか？楽しそう！Gamesture Storeでは、プレイヤーにゲーム内製品の最高のお得情報を提供する新しい方法を作りました。旧友とゲームパスを購入・共有したり、新しい友人に寄付したりしましょう。新人を報酬したり、自分に追加の長いブーストをあげましょう。'
    },
    cs: {
      slug: 'o-nas',
      title: 'O nás – Obchod Gamesture',
      description: 'Nový v obchodě? Skvělé! V obchodě Gamesture jsme vytvořili nový způsob, jak nabízet hráčům nejlepší nabídky herních produktů. Kupujte a sdílejte herní průkazy se starými přáteli nebo je darujte novým. Odměňte nováčka nebo si dopřejte extra dlouhý boost.'
    },
    bg: {
      slug: 'za-nas',
      title: 'За нас – Магазин Gamesture',
      description: 'Нов в магазина? Страхотно! Тук в Gamesture Store създадохме нов начин за предлагане на най-добрите оферти за игрови продукти на нашите играчи. Купувайте и споделяйте игрови пропуски със стари приятели или ги дарявайте на нови. Наградете начинаещ или се дарете с допълнителен дълъг бонус.'
    },
    nl: {
      slug: 'over-ons',
      title: 'Over ons – Gamesture Winkel',
      description: 'Nieuw in de winkel? Leuk! Hier bij Gamesture Store hebben we een nieuwe manier gecreëerd om de beste deals voor in-game producten aan onze spelers aan te bieden. Koop en deel spelpassjes met uw oude vrienden of doneer ze aan nieuwe. Beloon een nieuweling of geef uzelf een extra lange boost.'
    }
  },
  'activate-goat-offer': {
    en: {
      slug: 'activate-goat-offer',
      title: 'Activate GOAT offer - Gamesture store',
      description: 'Activate GOAT offer'
    },
    pl: {
      slug: 'aktywuj-goat-oferte',
      title: 'Aktywuj ofertę GOAT – Sklep Gamesture',
      description: 'Aktywuj ofertę GOAT'
    },
    de: {
      slug: 'goat-angebot-aktivieren',
      title: 'GOAT-Angebot aktivieren – Gamesture Shop',
      description: 'GOAT-Angebot aktivieren'
    },
    fr: {
      slug: 'activer-offre-goat',
      title: 'Activer l\'offre GOAT – Boutique Gamesture',
      description: 'Activer l\'offre GOAT'
    },
    es: {
      slug: 'activar-oferta-goat',
      title: 'Activar oferta GOAT – Tienda Gamesture',
      description: 'Activar oferta GOAT'
    },
    pt: {
      slug: 'ativar-oferta-goat',
      title: 'Ativar oferta GOAT – Loja Gamesture',
      description: 'Ativar oferta GOAT'
    },
    zh: {
      slug: 'activate-goat-offer',
      title: '激活 GOAT 优惠 – Gamesture 商店',
      description: '激活 GOAT 优惠'
    },
    ru: {
      slug: 'aktivirovat-predlozhenie-goat',
      title: 'Активировать предложение GOAT – Магазин Gamesture',
      description: 'Активировать предложение GOAT'
    },
    it: {
      slug: 'attiva-offerta-goat',
      title: 'Attiva offerta GOAT – Negozio Gamesture',
      description: 'Attiva offerta GOAT'
    },
    ko: {
      slug: 'activate-goat-offer',
      title: 'GOAT 오퍼 활성화 – Gamesture 스토어',
      description: 'GOAT 오퍼 활성화'
    },
    ja: {
      slug: 'activate-goat-offer',
      title: 'GOATオファーを有効化 – Gamesture ストア',
      description: 'GOATオファーを有効化'
    },
    cs: {
      slug: 'aktivovat-goat-nabidku',
      title: 'Aktivovat nabídku GOAT – Obchod Gamesture',
      description: 'Aktivovat nabídku GOAT'
    },
    bg: {
      slug: 'aktivirane-goat-predlozhenie',
      title: 'Активиране на оферта GOAT – Магазин Gamesture',
      description: 'Активиране на оферта GOAT'
    },
    nl: {
      slug: 'activeer-goat-aanbieding',
      title: 'GOAT-aanbieding activeren – Gamesture Winkel',
      description: 'GOAT-aanbieding activeren'
    }
  }
}
